export default "__VITE_ASSET__qEMkR2Ev__"